import { render } from "./FormDetail.vue?vue&type=template&id=31c2dbc4&scoped=true"
import script from "./FormDetail.vue?vue&type=script&lang=js"
export * from "./FormDetail.vue?vue&type=script&lang=js"

import "./FormDetail.vue?vue&type=style&index=0&id=31c2dbc4&scoped=true&lang=css"
import "./FormDetail.vue?vue&type=style&index=1&id=31c2dbc4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c2dbc4"]])

export default __exports__